import React from 'react'
import PropTypes from 'prop-types'
import { hasErrors } from './'
import FormError from './FormError'

const HiddenField = ({ field, form, ...props }) => {
  return (
    <div className="mb-6">
      <input
        {...field}
        {...props}
        value={props.value || ''}
        className={`w-full py-4 px-6 text-lg rounded-lg bg-primary-lighter placeholder-black ${
          hasErrors({ field, form })
            ? 'border border-error'
            : 'border border-transparent'
        }`}
        aria-labelledby={field.id}
      />
      {hasErrors({ field, form }) && (
        <FormError error={form.errors[field.name]} />
      )}
    </div>
  )
}

HiddenField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.string,
  }),
  errors: PropTypes.object,
  props: PropTypes.object,
  id: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
}

export default HiddenField
